import React from 'react'

import PropTypes from 'prop-types'

import { FullBannerLayout, DefaultBannerLayout } from './components'

import PrimaryBannerPreviewProvider from 'providers/PrimaryBannerPreviewProvider'

const PrimaryLevelBanner = ({
  size,
  handleOpenBanner,
  privacyPortalEnabled,
  privacyPortalUrl,
  onManageCookies,
  isCompact,
  isMobile,
  hideRejectButton,
}) => {
  const isFull = size === 'full' && !isMobile

  return (
    <PrimaryBannerPreviewProvider
      size={size}
      isCompact={isCompact}
      isMobile={isMobile}
      privacyPortalEnabled={privacyPortalEnabled}
      privacyPortalUrl={privacyPortalUrl}
      onManageCookies={onManageCookies}
      handleOpenBanner={handleOpenBanner}
      hideRejectButton={hideRejectButton}
    >
      {isFull ? <FullBannerLayout /> : <DefaultBannerLayout />}
    </PrimaryBannerPreviewProvider>
  )
}

PrimaryLevelBanner.propTypes = {
  size: PropTypes.oneOf(['default', 'medium', 'full']),
  handleOpenBanner: PropTypes.func.isRequired,
  description: PropTypes.string,
  privacyPortalEnabled: PropTypes.bool,
  privacyPortalUrl: PropTypes.string,
  onManageCookies: PropTypes.func,
  isCompact: PropTypes.bool,
  isMobile: PropTypes.bool,
  hideRejectButton: PropTypes.bool,
}

export default PrimaryLevelBanner
